import React from "react";
import { useTranslation } from "react-i18next";

import { DeviceNotSoldWarning } from "./DeviceNotSoldWarning";
import { DEVICE_STATUS, formatDeviceDate, formatDeviceDay, formatDeviceType } from "./deviceFormatters";

export function DeviceSearchResultsTable({ devices }) {

    const { t } = useTranslation();

    const formatLocation = (device) => {
        if (!device.locationName && !device.locationId)
            return "-";
        return `${device.locationName ?? "-"} (${device.locationId ?? "-"})`;
    };

    const statusCell = (device) => {
        switch (device.status) {
            case DEVICE_STATUS.NOT_SOLD:
                return <DeviceNotSoldWarning />;
            case DEVICE_STATUS.NOT_CONFIGURED:
                return t("mod_device_search_status_not_configured");
            case DEVICE_STATUS.ACTIVE:
                return t("mod_device_search_status_active");
            default:
                return "-";
        }
    };

    return (
        <div className="table-responsive">
            <table className="table table-hover">
                <thead>
                    <tr>
                        <th>{t("mod_device_search_bluetooth_id")}</th>
                        <th>{t("global_description")}</th>
                        <th>{t("global_type")}</th>
                        <th>{t("mod_device_search_last_activity")}</th>
                        <th>{t("global_location")}</th>
                        <th>{t("global_room")}</th>
                        <th>{t("mod_device_search_admin_email")}</th>
                        <th>{t("mod_device_search_warranty_start")}</th>
                        <th>{t("mod_device_search_status")}</th>
                    </tr>
                </thead>
                <tbody>
                    {devices.map(device => (
                        <tr key={device.uid}>
                            <td className="text-monospace">
                                {device.bluetoothId}
                                {device.multiIndex != null && devices.length > 1
                                    ? ` (#${device.multiIndex})`
                                    : ""}
                            </td>
                            <td>{device.description || "-"}</td>
                            <td>{formatDeviceType(device.type)}</td>
                            <td>{formatDeviceDate(device.lastActivity)}</td>
                            <td>{formatLocation(device)}</td>
                            <td>{device.roomName || "-"}</td>
                            <td>{device.locationAdminEmail || "-"}</td>
                            <td>{formatDeviceDay(device.warrantyStart)}</td>
                            <td>{statusCell(device)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}